import React from "react";
import map from "lodash/map";
import ExerciseLibraryItemSecondaryComponent from "./ExerciseLibraryItemSecondaryComponent";
import AthleteProfileMenu from "../../athlete-portal/profile/components/AthleteProfileMenu";
import SvgIcon from "../../../parts/SvgIcon";
import SettingsNav from "../../../parts/settings-nav";
import { MOVEMENTS } from "../../../constants";
import { useTranslation } from "react-i18next";

function ExerciseLibraryComponent({
  type,
  primary,
  primaryRepMax,
  secondaries,
  withWeight,
  fromMetric,
  activeUser,
  athlete,
  locals,
  query,
  organizationCoachId,
}) {
  const { t } = useTranslation("dashboard");
  const activeTab = primary;
  const pathname = locals.pathname;
  const isAthleteDashboard = pathname?.startsWith("/dashboard/settings");
  return (
    <main
      className={`${
        !isAthleteDashboard
          ? "Coaching-Athlete-Profile"
          : "settings Settings-Exercise-Library"
      } profile exercise-library`}
    >
      {pathname?.startsWith("/dashboard/settings") ? (
        <SettingsNav />
      ) : (
        <aside>
          <div className="exercise-library-back-header">
            {athlete && (
              <a
                href={
                  query.organizationCoach
                    ? `/athlete-portal/profile/?athlete=${athlete._id}&organizationCoach=${query.organizationCoach}`
                    : `/athlete-portal/profile/?athlete=${athlete._id}`
                }
              >
                <SvgIcon src="/img/new-icons/back-button.svg" alt={t("common:back")} /> {t("common:back")}
              </a>
            )}
          </div>
          <AthleteProfileMenu
            athlete={athlete}
            locals={locals}
            organizationCoachId={organizationCoachId}
          />
        </aside>
      )}
      <section>
        <h4>{t("exerciseLibrary.title")}</h4>
        <nav role="tablist">
          <a
            href={`/actions/refresh?primary=assistant`}
            aria-current={activeTab === "assistant" ? true : undefined}
          >
            {t("exerciseLibrary.accessories")}
          </a>
          <a
            href={`/actions/refresh?primary=squat`}
            aria-current={activeTab === "squat" ? true : undefined}
          >
            {t("exerciseLibrary.squat")}
          </a>
          <a
            href={`/actions/refresh?primary=bench`}
            aria-current={activeTab === "bench" ? true : undefined}
          >
            {t("exerciseLibrary.bench")}
          </a>
          <a
            href={`/actions/refresh?primary=deadlift`}
            aria-current={activeTab === "deadlift" ? true : undefined}
          >
            {t("exerciseLibrary.deadlift")}
          </a>
          <a
            href={`/actions/refresh?primary=clean`}
            aria-current={activeTab === "clean" ? true : undefined}
          >
            {t("exerciseLibrary.clean")}
          </a>
          <a
            href={`/actions/refresh?primary=jerk`}
            aria-current={activeTab === "jerk" ? true : undefined}
          >
            {t("exerciseLibrary.jerk")}
          </a>
          <a
            href={`/actions/refresh?primary=snatch`}
            aria-current={activeTab === "snatch" ? true : undefined}
          >
            {t("exerciseLibrary.snatch")}
          </a>
          <a
            href={`/actions/refresh?primary=overheadPress`}
            aria-current={activeTab === "overheadPress" ? true : undefined}
          >
            {t("exerciseLibrary.overheadPress")}
          </a>
          <a
            href={`/actions/refresh?primary=other`}
            aria-current={activeTab === "other" ? true : undefined}
          >
            {t("common:other")}
          </a>
          <a
            role="button"
            data-button-type="primary"
            href={
              primary !== "assistant"
                ? `/actions/refresh?modal[type]=add-secondary-movement&modal[primary]=${primary}`
                : `/actions/refresh?modal[type]=add-other-exercise`
            }
            sz="medium"
          >
            <SvgIcon
              src="/img/new-icons/add.svg"
              alt={t("exerciseLibrary.addNew")}
              noFilterOnLight={true}
            />
            {t("exerciseLibrary.addNew")}
          </a>
        </nav>
        <div className="Exercise-Library-Exercises">
          {primary !== "assistant" && primary !== "other" && (
            <ExerciseLibraryItemSecondaryComponent
              repMax={primaryRepMax}
              secondary={{ movement: MOVEMENTS[primary] }}
              primary={primary}
              i={0}
              athlete={athlete}
              query={query}
              primaryItem
            />
          )}

          {map(secondaries, (secondary, i) => {
            const repMaximumConversion = athlete
              ? activeUser.units === "imperial"
                ? fromMetric(secondary.repMaximum)
                : secondary.repMaximum
              : fromMetric(secondary.repMaximum);

            const repMax = withWeight(repMaximumConversion, activeUser.units);

            return (
              <ExerciseLibraryItemSecondaryComponent
                repMax={repMax}
                secondary={secondary}
                primary={primary}
                i={i}
                athlete={athlete}
                query={query}
                key={`${i}`}
              />
            );
          })}
        </div>
      </section>
    </main>
  );
}

export default ExerciseLibraryComponent;
